var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClipboardX(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 56,
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M10.02 23.036l18.41 18.41m-18.41 0l18.41-18.41M8.287 9.771V5.834l6.265.017c.508 0 .963-.367.998-.875.122-1.295.77-3.535 3.814-3.535 3.08 0 3.938 2.24 4.183 3.483.087.472.49.805.962.805h5.67v7.577l-21.91.053.018-3.045V9.77z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M37.688 9.858H.938v44.975h36.75V9.858z"
  })));
}
export default SvgClipboardX;